import { error, ERROR_INVALID_NUMBER, ERROR_INVALID_BIRTHDATE } from './NationalNumber'

// Generate checksum number to compare against parts.check
const luhn = (str) => {

    let sum = 0
    let v

    str += ''

    for (let i = 0; i < str.length; i++) {
        v = parseInt(str.charAt(i))
        v *= 2 - (i % 2)
        if (v > 9) {
            v -= 9
        }
        sum += v
    }

    return Math.ceil(sum / 10) * 10 - sum
}

const getParts = (ssn) => {

    //eslint-disable-next-line
    const search = new RegExp('^(?<century>\\d{2})(?<year>\\d{2})(?<month>\\d{2})(?<day>\\d{2})(?<sep>[\+\-]?)(?<num>(?!000)\\d{3})(?<check>\\d)$')
    const matches = search.exec(ssn)

    if (matches === null || matches.groups === undefined) {
        return null
    }

    const parts = matches.groups

    let d = new Date()
    let baseYear
    if (parts.century !== undefined) {
        const ssnYear = String(parts.century) + String(parts.year)
        if (d.getFullYear() - parseInt(ssnYear) < 100) {
            parts.sep = '-'
        } else {
            parts.sep = '+'
        }

    } else {
        if (parts.sep === '+') {
            baseYear = d.getFullYear() - 100
        } else {
            parts.sep = '-'
            baseYear = d.getFullYear()
        }
        parts.century = String(baseYear - parseInt(parts.year)).substring(0, 2)
    }

    return parts
}

const getBirthdateParts = (number) => {
    const search = new RegExp('^(?<century>\\d{2})(?<year>\\d{2})(?<month>\\d{2})(?<day>\\d{2})$')
    return search.exec(number)
}

const validateBirthdate = (number, birthdateOnly) => {
    const errors = []
    const matches = getBirthdateParts(number)

    if (matches === null || matches.groups === undefined) {
        errors.push(error(birthdateOnly ? ERROR_INVALID_BIRTHDATE : ERROR_INVALID_NUMBER))
        return errors
    }

    const parts = matches.groups

    if (parts.month < 1 || parts.month > 12 || parts.day < 1 || parts.day > 31) {
        errors.push(error(birthdateOnly ? ERROR_INVALID_BIRTHDATE : ERROR_INVALID_NUMBER))
        return errors
    }
    return errors
}

const validateNationalNumber = (number) => {

    const errors = []
    const parts = getParts(number)
    if (parts === null) {
        errors.push(error(ERROR_INVALID_NUMBER))
        return errors
    }

    const checkStr = parts.year + parts.month + parts.day + parts.num
    if (luhn(checkStr) !== parseInt(parts.check)) {
        errors.push(error(ERROR_INVALID_NUMBER))
    }
    return errors
}

export default (number) => {
    return {
        number: number,
        errors: [],
        format: function () {
            const longFormat = true
            if (!this.isValid()) {
                return this.number
            }
            const parts = getParts(this.number)
            if (longFormat) {
                // Long form is with century, and without separator YYYYMMDDXXXX
                return parts.century + parts.year + parts.month + parts.day + '-' + parts.num + parts.check
            }
            // Short format is default YYMMDD-XXXX
            return parts.year + parts.month + parts.day + '-' + parts.sep + parts.num + parts.check
        },
        formatMasked: function () {
            if (!this.isValid()) {
                return this.format()
            }
            const parts = getParts(this.number)
            return parts.century + parts.year + parts.month + parts.day + '-****'
        },
        formatUnmasked: function () {
            return this.format()
        },
        validate: function () {
            this.errors = []

            switch (this.number.length) {
                case 8:
                    this.errors = validateBirthdate(this.number)
                    break
                case 12:
                    this.errors = validateNationalNumber(this.number)
                    break
                default:
                    this.errors.push(error(ERROR_INVALID_NUMBER))
            }

            return this.errors
        },
        validateBirthdate: function () {
            return validateBirthdate(this.number, true)
        },
        validateNationalNumber: function () {
            return validateNationalNumber(this.number)
        },
        isValid: function () {
            return this.validate().length === 0
        },
        isValidBirthdate: function () {
            return this.validateBirthdate().length === 0
        },
        isValidNationalNumber: function () {
            return this.validateNationalNumber().length === 0
        },
        isNationalNumber: function () {
            return validateNationalNumber(this.number).length === 0
        },
        isMale: function () {
            if (!this.isValid() || !this.isNationalNumber()) {
                return false
            }

            const parts = getParts(this.number)
            const sexDigit = parts.num.substring(-1)

            return sexDigit % 2 === 1
        },
        isFemale: function () {
            if (!this.isValid()) {
                return false
            }
            return !this.isMale()
        },
        birthdate: function () {
            if (!this.isValid()) {
                return this.format()
            }

            return this.number.substring(0, 8)

        },
        formattedBirthdate: function () {
            if (!this.isValid()) {
                return this.format()
            }
            const parts = this.getBirthdateParts(this.number)
            return parts.century + parts.year + '-' + parts.month + '-' + parts.date
        },
    }
}
